import { Box } from '@factorialco/deprecated-design-system'
import { ContractsValueObjectsContractScheduleEnum } from 'generated/resources/graphql'

import { ContractPeriodType } from 'modules/contracts/components/NewContractHistory/types'

interface Props {
  status: ContractsValueObjectsContractScheduleEnum
  type?: ContractPeriodType
  children: React.ReactNode
}

const getStatusColor = (
  status: ContractsValueObjectsContractScheduleEnum,
  type?: ContractPeriodType
) => {
  if (status === 'ongoing') {
    switch (type) {
      case 'activity':
        return 'malibu1000'
      case 'inactivity':
        return 'grey400'
      default:
        return 'viridian1000'
    }
  }

  const colorMap = {
    upcoming: 'tangerine1000',
    expired: 'grey400',
  } as const

  return colorMap[status] ?? 'grey400'
}

export const Milestone = ({ status, type, children }: Props) => {
  const backgroundColor = getStatusColor(status, type)

  return (
    <Box flexDirection="row" gap="s16" position="relative" width="full">
      <Box paddingTop="s16">
        <Box
          height="s20"
          width="s20"
          alignItems="center"
          justifyContent="center"
          borderRadius={{ all: 'abs006' }}
          border={{
            all: {
              width: 's1',
              style: 'solid',
              color: 'grey400',
            },
          }}
          background={backgroundColor}
          style={{ zIndex: '2' }}
        />
      </Box>
      {children}
    </Box>
  )
}
